"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@main/constants");
var messages_enum_ie_1 = __importDefault(require("@main/enums/messages-enum-ie"));
var session_enum_1 = __importDefault(require("@main/enums/session-enum"));
var steps_1 = __importDefault(require("@main/enums/steps"));
var steps_enum_1 = __importDefault(require("@main/enums/steps-enum"));
var utils_1 = require("@main/utils");
var ej2_inputs_1 = require("@syncfusion/ej2-inputs");
var browser_i18n_1 = __importDefault(require("browser-i18n"));
var disable_browser_back_navigation_1 = __importDefault(require("disable-browser-back-navigation"));
var mustache_1 = __importDefault(require("mustache"));
var sessionstorage_1 = __importDefault(require("sessionstorage"));
var tsdom_1 = __importDefault(require("tsdom"));
var web_agent_1 = __importDefault(require("@main/core/web/web-agent"));
var email_tools_1 = __importDefault(require("../email-tools"));
var Common = {
    disableBackNavigator: function () {
        disable_browser_back_navigation_1.default();
    },
    isIE: function () {
        var isIE = false;
        var ua = window.navigator.userAgent;
        var oldIe = ua.indexOf('MSIE ');
        var newIe = ua.indexOf('Trident/');
        if (oldIe > -1 || newIe > -1) {
            isIE = true;
        }
        return isIE;
    },
    generateTemplateBlock: function (templateId, content, params) {
        var template = tsdom_1.default(templateId).html();
        var customTags = ['<%', '%>'];
        var msg = mustache_1.default.render(content, params);
        var rendered = mustache_1.default.render(template, __assign({ msg: msg }, params), {}, customTags);
        return rendered;
    },
    hideSubMail: function () {
        tsdom_1.default('#email').closest('.container-label').find('#submail').remove();
    },
    appendSubMail: function () {
        var i18n = Common.getI18n();
        var context = Common.loadContext();
        var msg = mustache_1.default.render(i18n.__('submail'), context);
        tsdom_1.default('#email').closest('.container-label').find('#submail').remove();
        tsdom_1.default('#email').closest('.container-label').append("\n    <div id='submail'>" + msg + "</div>\n    ");
    },
    appendInputErrorMessage: function (name, message) {
        var context = Common.loadContext();
        var msg = mustache_1.default.render(message, context);
        tsdom_1.default("input[name=" + name + "]")
            .closest('.container-input,.otp_container')
            .find('.e-error')
            .remove();
        tsdom_1.default("input[name=" + name + "]").closest('.container-input,.otp_container')
            .append("\n    <span class=\"e-error\" id=\"email-info\" style=\"display: flex !important;\">" + msg + "</span>\n    ");
    },
    removeInputErrorMessage: function (name) {
        tsdom_1.default(name + "#email-info.e-error").remove();
    },
    redirectNextStep: function () {
        var context = Common.loadContext();
        var alias = context.alias, purl = context.purl, workflowType = context.workflowType;
        var steps = steps_1.default[workflowType];
        var stepsPath = Object.keys(steps);
        var currentStepPath = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
        var index = stepsPath.indexOf(currentStepPath);
        var nextStepPath = stepsPath[index + 1];
        if (workflowType === steps_enum_1.default.DIRECT_STEPS ||
            workflowType === steps_enum_1.default.DIRECT_STEPS_V3) {
            window.location.href = window.location.origin + "/" + alias + "/" + nextStepPath;
        }
        else if (workflowType === steps_enum_1.default.PURL_STEPS ||
            workflowType === steps_enum_1.default.PURL_STEPS_V3) {
            window.location.href = "" + window.location.origin + purl + "/" + nextStepPath;
        }
        else if (workflowType === steps_enum_1.default.SECURITY_STEPS ||
            workflowType === steps_enum_1.default.SECURITY_STEPS_V3) {
            window.location.href = "" + window.location.origin + purl + "/splus/" + nextStepPath;
        }
    },
    redirectPreviousStep: function () {
        var context = Common.loadContext();
        var alias = context.alias, purl = context.purl, workflowType = context.workflowType;
        var steps = steps_1.default[workflowType];
        var stepsPath = Object.keys(steps);
        var currentStepPath = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
        var index = stepsPath.indexOf(currentStepPath);
        var nextStepPath = stepsPath[index - 1];
        var url = '';
        if (workflowType === steps_enum_1.default.SECURITY_STEPS ||
            workflowType === steps_enum_1.default.SECURITY_STEPS_V3) {
            url = "" + window.location.origin + purl + "/splus/" + nextStepPath;
        }
        else if (workflowType === steps_enum_1.default.DIRECT_STEPS ||
            workflowType === steps_enum_1.default.DIRECT_STEPS_V3) {
            url = window.location.origin + "/" + alias + "/" + nextStepPath;
        }
        else if (workflowType === steps_enum_1.default.PURL_STEPS ||
            workflowType === steps_enum_1.default.PURL_STEPS_V3) {
            url = "" + window.location.origin + purl;
        }
        window.location.href = url;
    },
    redirectEndStep: function () {
        var context = Common.loadContext();
        var alias = context.alias, purl = context.purl, workflowType = context.workflowType;
        var url = '';
        if (workflowType === steps_enum_1.default.DIRECT_STEPS ||
            workflowType === steps_enum_1.default.DIRECT_STEPS_V3) {
            url = window.location.origin + "/" + alias + "/confirmation";
        }
        else if (workflowType === steps_enum_1.default.PURL_STEPS ||
            workflowType === steps_enum_1.default.PURL_STEPS_V3) {
            url = "" + window.location.origin + purl + "/confirmation";
        }
        else if (workflowType === steps_enum_1.default.SECURITY_STEPS ||
            workflowType === steps_enum_1.default.SECURITY_STEPS_V3) {
            url = "" + window.location.origin + purl + "/splus/confirmation";
        }
        window.location.href = url;
    },
    extratFormValues: function (form) {
        var obj = {};
        var elements = form.querySelectorAll('input, select, textarea');
        Array.from(elements).reduce(function (res, item) {
            var element = item;
            var name = element.name, value = element.value, type = element.type, checked = element.checked;
            if (type === 'radio') {
                if (checked) {
                    res[name] = value;
                }
            }
            else {
                res[name] = value;
            }
            return res;
        }, obj);
        return obj;
    },
    registerForms: function (forms) {
        var _loop_1 = function (form) {
            var formObj = new ej2_inputs_1.FormValidator(form.formSelector, form.options);
            if (form.submitSelector) {
                tsdom_1.default(form.submitSelector).attr({
                    disabled: 'true',
                });
                tsdom_1.default(form.formSelector + " input").on(constants_1.CLICK, function (event) {
                    Common.activateButton(form);
                });
                tsdom_1.default(form.formSelector + " input").on(constants_1.KEY_UP, function (event) {
                    Common.activateButton(form);
                });
            }
            tsdom_1.default(form.formSelector).on('submit', function (event, element) { return __awaiter(void 0, void 0, void 0, function () {
                var params, response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            event.preventDefault();
                            if (!formObj.validate()) return [3 /*break*/, 4];
                            params = Common.extratFormValues(element);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, form.onSubmit(params)];
                        case 2:
                            response = _a.sent();
                            form.onSuccess(response);
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            if (utils_1.isErrorWithAttr(error_1, [constants_1.RESPONSE])) {
                                form.onFail(error_1.response);
                            }
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        for (var _i = 0, forms_1 = forms; _i < forms_1.length; _i++) {
            var form = forms_1[_i];
            _loop_1(form);
        }
    },
    activateButton: function (form) {
        var _a;
        if (form.submitSelector) {
            var currentForm = document.getElementById(form.formSelector.replace('#', ''));
            if (currentForm.checkValidity()) {
                (_a = document
                    .getElementById(form.submitSelector.replace('#', ''))) === null || _a === void 0 ? void 0 : _a.removeAttribute('disabled');
            }
            else {
                tsdom_1.default(form.submitSelector).attr({
                    disabled: 'true',
                });
            }
        }
    },
    onMessage: function (signinWindow) {
        return function (message) {
            var fetchTokenCallback = message.replace(constants_1.CALL_BACK, 'connect');
            window.location.href = fetchTokenCallback;
            signinWindow === null || signinWindow === void 0 ? void 0 : signinWindow.close();
        };
    },
    loadContext: function () {
        var data = sessionstorage_1.default.getItem(session_enum_1.default.CONTEXT);
        if (data) {
            var context = JSON.parse(data);
            return context;
        }
        return {};
    },
    getI18n: function () {
        var lang = window.webContext.lang;
        if (Common.isIE()) {
            return {
                __: function (key) {
                    if (messages_enum_ie_1.default[key] && messages_enum_ie_1.default[key][lang]) {
                        return messages_enum_ie_1.default[key][lang];
                    }
                    return 'their is an error';
                },
            };
        }
        if (window.adhererI18n) {
            return window.adhererI18n;
        }
        var i18n = new browser_i18n_1.default({
            language: lang,
            path: '/locales',
            extension: '.json',
            objectNotation: true,
            cookie: constants_1.LOCAL,
            queryParameter: constants_1.LANG,
        });
        window.adhererI18n = i18n;
        return i18n;
    },
    getPopularDomainEmails: function () { return __awaiter(void 0, void 0, void 0, function () {
        var popularEmails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.popularEmails) {
                        return [2 /*return*/, window.popularEmails];
                    }
                    return [4 /*yield*/, web_agent_1.default().get(constants_1.GET_POPULAR_DOMAIN_EMAILS)];
                case 1:
                    popularEmails = _a.sent();
                    window.popularEmails = popularEmails;
                    return [2 /*return*/, popularEmails];
            }
        });
    }); },
    appendEmailValidationError: function () {
        var i18n = Common.getI18n();
        var context = Common.loadContext();
        var msg = mustache_1.default.render(i18n.__('mailIncorrect'), context);
        Common.removeInputErrorMessage('span');
        tsdom_1.default('input[name=email]').closest('.container-input,.otp_container')
            .append("\n<span class=\"e-error\" id=\"email-info\" style=\"display: flex !important;\">" + msg + "</span>\n");
    },
    emailEventInputHandler: function (e, element) { return __awaiter(void 0, void 0, void 0, function () {
        var inputElement, emailInputValue, shouldBeCcu, result, arr, entredDomain_1, emailPart1_1, isDDLDisplayed_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inputElement = element;
                    emailInputValue = inputElement.value;
                    if (emailInputValue !== '' &&
                        !email_tools_1.default.validteEmailRegex(emailInputValue)) {
                        Common.appendEmailValidationError();
                    }
                    shouldBeCcu = tsdom_1.default('.radio').hasClass('checked');
                    if (!shouldBeCcu) return [3 /*break*/, 3];
                    if (!(emailInputValue.indexOf('@') !== -1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Common.getPopularDomainEmails()];
                case 1:
                    result = _a.sent();
                    arr = result.data;
                    tsdom_1.default('#email-autocomplete-list');
                    entredDomain_1 = emailInputValue.substring(emailInputValue.indexOf('@') + 1);
                    emailPart1_1 = emailInputValue.substring(0, emailInputValue.indexOf('@') + 1);
                    tsdom_1.default('#email-autocomplete-list').html('');
                    isDDLDisplayed_1 = false;
                    arr.forEach(function (domain) {
                        Common.removeInputErrorMessage('span');
                        if (domain.toLowerCase().includes(entredDomain_1.toLowerCase()) ||
                            entredDomain_1 === '') {
                            isDDLDisplayed_1 = true;
                            var b = document.createElement('DIV');
                            b.innerHTML = emailPart1_1 + domain.toLowerCase();
                            b.innerHTML += "<input type='hidden' value='" + emailPart1_1 + domain.toLowerCase() + "'>";
                            tsdom_1.default('#email-autocomplete-list').append(b);
                            b.addEventListener('click', function () {
                                var selectedEmail = this.getElementsByTagName('input')[0].value;
                                inputElement.value = selectedEmail;
                                Common.removeInputErrorMessage('span');
                                tsdom_1.default('#email-autocomplete-list').html('');
                            });
                        }
                    });
                    if (!isDDLDisplayed_1) {
                        if (!email_tools_1.default.validteEmailRegex(emailInputValue)) {
                            Common.appendEmailValidationError();
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    tsdom_1.default('#email-autocomplete-list').html('');
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); },
};
exports.default = Common;
